<template>
  <td class="text-justify">
    <div v-for="(message, messageNr) in messagePool" :key="messageNr">
      <span>{{ messageNr + 1 }}:&nbsp;</span>
      <span>{{ message | messageFilter }}</span>
    </div>
  </td>
</template>
<script>
export default {
  data() {
    return {
      messagePool: []
    };
  },
  created() {
    this.messagePool = this.content;
  },
  props: {
    content: {
      required: true
    }
  },
  filters: {
    messageFilter(item) {
      switch (item.type) {
        case 1:
          return "Gif Nachricht";
        case 2:
          return "Gift Nachricht";
        case 3:
          return "Blink Nachricht";
        case 4:
          return "Image Nachricht";
        default:
          return item;
      }
    }
  }
};
</script>
